import { useAppSelector as useSelector } from 'dux/app/hooks';

import CheckoutBlock from 'Apps/Checkout/Blocks/CheckoutBlock';

import { Typography } from 'Components/Typography';

import { getCartBrushes } from 'dux/checkoutCart/selectors';

const CheckoutBrushSummary = () => {
  const brushes = useSelector(getCartBrushes);
  return (
    <>
      {brushes
        .filter(brush => brush.customization)
        .map(brush => (
          <CheckoutBlock key={brush.type} dataTestId="giftee-infos" title="Brush details">
            <Typography variant="p2">Monogram:</Typography>
            <Typography color="grey" variant="p3">
              {brush.customization.monograms || 'None'}
            </Typography>
            {brush.customization.message && (
              <>
                <br />
                <Typography variant="p2">Gift Message:</Typography>
                <Typography color="grey" variant="p3">
                  {brush.customization.message}
                </Typography>
              </>
            )}
          </CheckoutBlock>
        ))}
    </>
  );
};

export default CheckoutBrushSummary;
